export const UNKNOWN_START_DATE = "4020-01-01T00:00:00.000Z";

export const TERMS_OF_USE_VERSION = "2021-05-11";

export const TEST_ID_PROPERTY_MANAGER_NAV_DASHBOARD =
  "property-manager-nav-dashboard";

export const TEST_ID_PROPERTY_MANAGER_PORTFOLIO_COMPARABLES_CHART =
  "property-manager-portfolio-comparables-chart";

export const TEST_ID_PROPERTY_MANAGER_PORTFOLIO_EFFICIENCY_CHART =
  "property-manager-portfolio-efficiency-chart";

export const TEST_ID_PROPERTY_MANAGER_PORTFOLIO_EXAMPLE_PROPERTY =
  "property-manager-portfolio-example-property";
